import { stdObject } from "../data/types/stdObject";

export const arrangeBatches = ({ data, table, batchesBox }: stdObject) => {
  const { line, item, serie2 } = data;
  const newBatchesBox = [...batchesBox];
  const batchIndexByKey = new Map(
    newBatchesBox.map((v: stdObject, i: number) => [v.IDBA0, i]),
  );
  const batchesTable = table.map((e: stdObject) => {
    if (serie2) {
      const keyIndex = batchIndexByKey.get(e.data.IDBA0);
      if (keyIndex !== undefined) {
        newBatchesBox[keyIndex] = {
          ...newBatchesBox[keyIndex],
          TRABA0: e.data.CANBA0,
        };
      }
      return {
        ...e,
        ARTBA0: item,
        LINBA0: line,
        TRABA0: e.data.CANBA0,
      };
    } else {
      newBatchesBox.push({
        IDBA0: e.data.IDBA0,
        CANBA0: e.data.CANBA0,
        EXPBAT: e.data.EXPBAT,
      });
      return {
        IDBA0: e.data.IDBA0,
        ARTBA0: item,
        LINBA0: line,
        CANBA0: e.data.CANBA0,
        EXPBAT: e.data.EXPBAT,
      };
    }
  });
  return { batchesTable, batchesBox: newBatchesBox };
};
